import { useEffect } from 'react'
import { useLocation, useHistory } from 'react-router-dom'

import { connect } from 'react-redux'

const CancelPage = (props) => {
  const history = useHistory()
  const location = useLocation()

  useEffect(() => {
    const params = new URLSearchParams(location.search)
    const callId = params.get('id')
    const callType = params.get('type')

    if (callId && callType) {
      sessionStorage.setItem(
        'pendingCancelCall',
        JSON.stringify({ id: callId, type: callType })
      )

      if (props.user) {
        history.push('/book')
      } else {
        history.push('/pro/join')
      }
    } else {
      window.location.replace('https://join.talkpro.com')
    }
  }, [props, location.search, history])

  return null
}

const mapStateToProps = ({ auth: { error, isPro, user } }) => ({
  authError: error,
  user,
  isPro,
})

export default connect(mapStateToProps)(CancelPage)
